import { Model } from '@vuex-orm/core'

export default class Load extends Model {
  static entity = 'loads'

  // static primaryKey = ['slab_id', 'id']

  static fields () {
    return {
      id: this.string(''),
      // project_id: this.number(0),
      slab_id: this.string(''),
      load_type_id: this.number(1),
      // sequence: this.number(1),
      data: this.attr({}),
      load_phase_id: this.number(1),
      description: this.string('')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/models/Load.js